import { render, staticRenderFns } from "./groupset.vue?vue&type=template&id=0a112d6b&scoped=true"
import script from "./groupset.vue?vue&type=script&lang=js"
export * from "./groupset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a112d6b",
  null
  
)

export default component.exports